module.exports = "/_next/static/images/game-1-phone-gallery-08-25-1502-ff1bb9e38f7db64974be47443b6fcaff.jpg";